import React from "react";
import "./About.css";
import "./Examples.css";
import { Card } from "@cadenza/ui";

const Examples = () => {
  const bgUrl = `${import.meta.env.BASE_URL}riva.jpg`;
  const backgroundStyle = {
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(${bgUrl})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "100%", // This sets the height to full view height
    color: "white", // Assuming you want white text for visibility
  };

  const examples = [
    {
      id: 1,
      title: "Example 1",
      description: "This is the description for example 1.",
      imageUrl: "https://via.placeholder.com/300",
    },
    {
      id: 2,
      title: "Example 2",
      description: "This is the description for example 2.",
      imageUrl: "https://via.placeholder.com/300",
    },
    {
      id: 3,
      title: "Example 3",
      description: "This is the description for example 3.",
      imageUrl: "https://via.placeholder.com/300",
    },
    {
      id: 4,
      title: "Example 4",
      description: "This is the description for example 4.",
      imageUrl: "https://via.placeholder.com/300",
    },
    // Add more mock examples as needed
  ];

  return (
    <>
      <div className="top-bar"></div>
      <div className="main-content">
        <div className="flex-pane" style={backgroundStyle}>
          <div className="overlay">
            <h1 className="examples-title">Examples</h1>
            <div className="examples-grid">
              {examples.map((example) => (
                <Card
                  key={example.id}
                  title={example.title}
                  description={example.description}
                  imageUrl={example.imageUrl}
                  onClick={() => alert(`Clicked on ${example.title}`)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Examples;
